import React, { Component } from "react";
import { Grid, Button } from "semantic-ui-react";
import GameScore from "./GameScore";
import TriviaCard from "./TriviaCard";
import TriviaReview from "./TriviaReview";

class TriviaViewer extends Component {
  constructor(props) {
    super(props);
    const remainingQues = [...props.Questions];
    this.state = {
      remainingQues: props.Randomize === false ? remainingQues: this.shuffleArray(remainingQues),
      name: props.Name,
      allQuestions: props.Questions,
      totalQuestions: props.Questions.length,
      answeredQuestions: 0,
      correctCount: 0,
      incorrectCount: 0,
      completed: false,
      active: {
        questionText: undefined,
        possibleAnswers: [],
      }
    };
  }

  componentDidMount() {
    this.placeQuestion(this.state.remainingQues);
  }

  shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  placeQuestion = (questions) => {
    if (questions[0] !== undefined){
      let currentQuestion = {
        questionText: questions[0].title,
        possibleAnswers: this.shuffleArray(questions[0].answers)
      }
      
      this.state.remainingQues.shift();

      this.setState({
        active: currentQuestion
      })
    } else{
      this.setState({
        completed: true
      })
    }
  }

  submitAnswer = (answer) => {
    this.setState({
      answeredQuestions: this.state.answeredQuestions + 1,
      correctCount: answer.isCorrect ? this.state.correctCount + 1 : this.state.correctCount,
      incorrectCount: answer.isCorrect ? this.state.incorrectCount : this.state.incorrectCount + 1
    })

    this.placeQuestion(this.state.remainingQues);
    
  }


  render(){
    return(
      <Grid textAlign="center" verticalAlign="middle">
        {
          !this.state.completed && this.state.active.questionText !== undefined ?
            <Grid.Row>
              <Grid.Column>
                <TriviaCard key={this.state.active.questionText} Answered={this.state.answeredQuestions} Total={this.state.totalQuestions} Active={this.state.active} SubmitAnswer={this.submitAnswer} />
              </Grid.Column>
            </Grid.Row>
          :
            <Grid.Row columns={2}>
              <Grid.Column>
                <TriviaReview key="TriviaReview" Questions={this.state.allQuestions} Name={this.state.name} />
              </Grid.Column>
              <Grid.Column>
                <Button primary size='small' content="Try again or select another Trivia!" onClick={ () => window.location.reload() } />
              </Grid.Column>
            </Grid.Row>
        }
        <Grid.Row>
          <Grid.Column>
            <GameScore key="GameScore" CorrectCount={this.state.correctCount} IncorrectCount={this.state.incorrectCount} TotalCount={this.state.totalQuestions} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
export default TriviaViewer;